import { Component, DestroyRef, inject, Input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { HotelFiltersService } from "@app/services/hotelfilters.service";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "clever-beliebtefilter",
  templateUrl: "./beliebtefilter.html",
  styleUrl: "./beliebtefilter.scss",
  standalone: false,
})
export class Beliebtefilter {
  popularFilters: { name: string; code: string }[] = [
    { name: "All inclusive", code: "AI" },
    { name: "Outdoor pool", code: "pol" },
    { name: "Direkte Strandlage", code: "bea" },
    { name: "WLAN", code: "fwi" },
    { name: "Meerblick", code: "meer" },
    { name: "Direktflug", code: "flug" },
    { name: "Massage", code: "wms" },
    { name: "Transfer zum Hotel", code: "MT" },
    { name: "Fitnessraum", code: "sfr" },
    { name: "Miniclub", code: "emc" },
  ];

  selectedFilters: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(
    []
  );
  destRef = inject(DestroyRef);
  keywords = ["pol", "fwi", "bea", "wms", "sfr", "emc"];

  @Input() scroll: boolean;

  constructor(private filterService: HotelFiltersService) {
    this.getExistingFilters();
  }

  getExistingFilters() {
    this.filterService.getfilters$
      .pipe(takeUntilDestroyed(this.destRef))
      .subscribe((res) => {
        this.selectedFilters.next([]);
        if (res) {
          if (
            res.boardTypeList &&
            res.boardTypeList.find((i) => i.code == "AI")
          ) {
            if (!this.selectedFilters.value.includes("AI")) {
              let cur = this.selectedFilters.value;
              this.selectedFilters.next([...cur, "AI"]);
            }
          }
          if (res.keywordList) {
            res.keywordList.forEach((key) => {
              if (this.keywords.includes(key.code)) {
                let cur = this.selectedFilters.value;
                this.selectedFilters.next([...cur, key.code]);
              }
            });
          }
          if (res.zommermitmeerblick) {
            let cur = this.selectedFilters.value;
            this.selectedFilters.next([...cur, "meer"]);
          }
          if (res.flight && res.flight.directness == "N") {
            let cur = this.selectedFilters.value;
            this.selectedFilters.next([...cur, "flug"]);
          }
          if (res.transferlist && res.transferlist.includes("MT")) {
            let cur = this.selectedFilters.value;
            this.selectedFilters.next([...cur, "MT"]);
          }
        }
      });
  }

  select(evt) {
    let updated: string[];
    if (evt.code == "AI") {
      updated = this.toggleAllInclusive(evt);
    } else if (this.keywords.includes(evt.code)) {
      updated = this.keywordToggle(evt);
    } else if (evt.code == "meer") {
      updated = this.togglemeer(evt);
    } else if (evt.code == "flug") {
      updated = this.toggleFlug(evt);
    } else if (evt.code == "MT") {
      updated = this.toogleTransfer(evt);
    }
    this.selectedFilters.next(updated);
    this.getExistingFilters();
  }

  toggleAllInclusive(ev) {
    let current = this.selectedFilters.value;
    if (current.includes(ev.code)) {
      this.filterService.boardTypeList(
        {
          code: "AI",
          name: "All Inclusive",
        },
        false,
        true
      );
      return current.filter((item) => item !== ev.code);
    } else {
      this.filterService.boardTypeList(
        {
          code: "AI",
          name: "All Inclusive",
        },
        true,
        true
      );
      return [...current, ev.code];
    }
  }

  keywordToggle(ev) {
    let current = this.selectedFilters.value;
    let save = true;
    let res: string[];
    if (current.includes(ev.code)) {
      save = false;
      res = current.filter((item) => item !== ev.code);
    } else {
      save = true;
      res = [...current, ev.code];
    }
    this.filterService.keywordList({ code: ev.code, name: ev.name }, save);
    return res;
  }

  togglemeer(ev) {
    let current = this.selectedFilters.value;
    let meer = false;
    let res: string[];
    if (current.includes(ev.code)) {
      meer = false;
      res = current.filter((item) => item !== ev.code);
    } else {
      meer = true;
      res = [...current, ev.code];
    }
    this.filterService.zommermitmeerblick(meer, true);
    return res;
  }

  toggleFlug(ev) {
    let current = this.selectedFilters.value;
    let res: string[];
    if (current.includes(ev.code)) {
      res = current.filter((item) => item !== ev.code);
      this.filterService.directness("", true);
    } else {
      res = [...current, ev.code];
      this.filterService.directness("N", true);
    }
    return res;
  }

  toogleTransfer(ev) {
    let current = this.selectedFilters.value;
    let res: string[];
    if (current.includes(ev.code)) {
      res = current.filter((item) => item !== ev.code);
      this.filterService.transferlist("MT", false, true);
    } else {
      res = [...current, ev.code];
      this.filterService.transferlist("MT", true, true);
    }
    return res;
  }
}
